// src/pages/KakaoCallback.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function KakaoCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code) {
      fetch("http://localhost:4000/kakao/token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code }),
      })
        .then((res) => res.json())
        .then((data) => {
          const accessToken = data.access_token;

          return fetch("http://localhost:4000/kakao/user", {
            headers: { Authorization: accessToken },
          });
        })
        .then((res) => res.json())
        .then((userData) => {
          const { email, profile, properties } = userData.kakao_account;
          const nickname = properties?.nickname || "";
          const profile_image = profile?.profile_image_url || null;

          navigate("/register", {
            state: {
              email,
              nickname,
              profile_image,
              provider: "kakao",
            },
          });
        })
        .catch((err) => {
          console.error("카카오 로그인 실패:", err);
          navigate("/");
        });
    }
  }, [navigate]);

  return <div>카카오 로그인 처리 중입니다...</div>;
}

export default KakaoCallback;
